import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { BillingColumns } from '../BillingColumns'
import { DescriptionMode } from '../DescriptionMode'
import LinesTotal from '../details-total/lines-total/LinesTotal'
import { ComputedPrice } from '../../../../../../lib/graphql'

interface IDetailsTotalProps {
  label?: string
  total: {
    price: ComputedPrice
    priceOwner: ComputedPrice
    ownerFees: ComputedPrice
  }
  className?: string
  descriptionMode?: DescriptionMode
  columns: BillingColumns[]
  showAdjustments?: boolean
  noColor?: boolean
}

const DetailsTotalOwner = ({
  total,
  className,
  descriptionMode,
  columns,
  showAdjustments = false,
}: IDetailsTotalProps) => {
  return (
    <div className={clsx(s.blockContainer, className)}>
      <LinesTotal
        label={
          <>
            <FormattedMessage
              id='ui.DetailsTotalOwner.totalBrut'
              defaultMessage='Total Brut de vos prestations'
            />{' '}
            <span className={s.regular}>
              (
              <FormattedMessage
                id='ui.DetailsTotalOwner.totalShownToClient'
                defaultMessage='montant affiché au client'
              />
              )
            </span>
          </>
        }
        price={total.price}
        descriptionMode={descriptionMode}
        columns={columns}
        showAdjustments={showAdjustments}
        className={clsx(s.colored, s.bold)}
      />
      <LinesTotal
        label={
          <span>
            <FormattedMessage
              id='ui.DetailsTotalOwner.commission'
              defaultMessage='Commission Naboo (facturée séparément)'
            />
          </span>
        }
        price={{
          priceWithoutVat: total.ownerFees.priceWithoutVat * -1,
          priceWithVat: total.ownerFees.priceWithVat * -1,
          vat: total.ownerFees.vat * -1,
          vatRate: total.ownerFees.vatRate,
        }}
        descriptionMode={descriptionMode}
        columns={columns}
        showAdjustments={showAdjustments}
        className={clsx(s.regular, s.light)}
      />
      <LinesTotal
        label={
          <span>
            <FormattedMessage
              id='ui.DetailsTotalOwner.totalNet'
              defaultMessage='Total Net de vos prestations (montant qui vous est reversé)'
            />
          </span>
        }
        price={total.priceOwner}
        descriptionMode={descriptionMode}
        columns={columns}
        showAdjustments={showAdjustments}
        className={clsx(s.regular, s.colored)}
      />
    </div>
  )
}

export default DetailsTotalOwner
